/*
 * Component called by <Landing /> or <AnnouncementLandiing />
 */
import React                        from 'react'
import { announcementIdAction }     from "../Redux/Actions"
import axios                        from "axios"
import Box                          from "@material-ui/core/Box"
import { CLIENT_PUBLIC_TOKEN }      from '../config'
import { node_server }              from '../Helpers'
import DeleteIcon                   from '@material-ui/icons/Delete';
import Divider                      from '@material-ui/core/Divider';
import EditIcon                     from '@material-ui/icons/Edit';
import Grid                         from "@material-ui/core/Grid"
import { Link }                     from "react-router-dom"
import IconButton                   from '@material-ui/core/IconButton';
import MoreVertIcon                 from '@material-ui/icons/MoreVert';
import PropTypes                    from 'prop-types'
import { store }                    from "../Redux/Store"
import Typography                   from "@material-ui/core/Typography"

const Announcement = ({ paragraph, synopsis, i, announcementId, showOneAnnouncement, editOneAnnouncement, updateAfterDeleteAnnouncement, title }) => {

   const { authorizedToCrudAnnouncements } = store.getState()

   const handleDelete = () => {
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.delete(node_server + `announcement/deleteOneAnnouncement/${announcementId}`)
      .then(res => res.data)
      .then(data => {
         return 1
      })
      
      updateAfterDeleteAnnouncement(announcementId)
   }

   const handleEdit = () => {
      sendAnnouncementIdToStore(announcementId)
      editOneAnnouncement(announcementId)
   }
   
   const handleShow = () => {
      sendAnnouncementIdToStore(announcementId)
      showOneAnnouncement(announcementId)
   }

   const sendAnnouncementIdToStore = (announcementId) => {
      store.dispatch(announcementIdAction(announcementId))
   }

   return (
      <Box key={announcementId} >
         {i === 0 ? null :
               <Box style={{ width: "100%", paddingTop: "1rem" }}>
                  <Divider light />
               </Box>
         }
         <Grid container direction="row">
               <Grid item xs={9} >
                  <Typography style={{ textAlign: "left", marginTop: "1rem" }} >
                     <strong>{title}</strong>
                  </Typography>
               </Grid>
               <Grid item xs={3} >
                  {/* If paragraph[0] does not exist then the only text available is the title and the synopsis,
                      so do not allow navigation to the ShowOneAnnouncement Page. */}
                  {!paragraph[0] ?
                     null :
                     <Link to="/ShowOneAnnouncement" >
                     <IconButton data-testid='announcement-button' onClick={handleShow}>
                        <MoreVertIcon />
                     </IconButton>
                     </Link>
                  }
                  {authorizedToCrudAnnouncements ?
                     <IconButton onClick={handleEdit}>
                           <EditIcon />
                     </IconButton>
                     : null}
                  {authorizedToCrudAnnouncements ?
                     <IconButton value={announcementId} onClick={handleDelete} >
                           <DeleteIcon />
                     </IconButton>
                     : null}
               </Grid>
         </Grid>

         <Typography style={{ textAlign: "left" }} >
               {synopsis}
         </Typography>
      </Box>
   )
}

Announcement.propTypes = {
   editOneAnnouncement: PropTypes.func,
   i: PropTypes.number,
   id: PropTypes.string,
   paragraph: PropTypes.array,
   showOneAnnouncement: PropTypes.func,
   synopsis: PropTypes.string,
   title: PropTypes.string,
   updateAfterDeleteAnnouncement: PropTypes.func
}

export default Announcement
